module.exports = __webpack_public_path__ + "img/KSC02302.55189dd6.jpg";